<div class="cms__content">
    <div class="top__heading">
        <h3>Whitelist SMS</h3>
      </div>

      <form action="" class="form__style" [formGroup]="whitelistForm" >
          <div class="row">
            <div class="col-12 col-md-6">
                <label for="clientIP">Client IP</label>
                <input type="text" class="custom__field" formControlName="client_ip" >
            </div>
            <div class="col-12 col-md-6">
                <label for="clientIP">Client Name</label>
                <input type="text" class="custom__field" formControlName="client_name" >
            </div>
          </div>
      </form>
      <div class="button__group">
        <button class="cta float-right" [disabled]="whitelistForm.invalid"  (click)="whitelistForm.valid? submit() : null" >Submit</button>
      </div>
</div>
